import { z } from 'zod';

import { dashboardT } from '../../../../../lib/messages';

export const brandDialogSchema = z.object({
  agencyId: z.string().optional(),
  name: z
    .string()
    .trim()
    .min(1, dashboardT('brands.form.nameRequired'))
    .max(200, dashboardT('brands.form.nameTooLong')),
  industry: z.string().min(1, dashboardT('brands.form.industryRequired')),
  details: z.string(),
  url: z
    .string()
    .trim()
    .refine((value) => {
      if (!value) return true;
      if (URL.canParse(value)) return Boolean(new URL(value).hostname);
      const withProtocol = `https://${value}`;
      return (
        !/\s/.test(value) &&
        URL.canParse(withProtocol) &&
        new URL(withProtocol).hostname.includes('.')
      );
    }, dashboardT('brands.form.urlInvalid')),
  countryCodes: z.array(z.string()),
  logo: z.custom<File | null | undefined>(
    (value) => value === undefined || value === null || value instanceof File,
  ),
  removeLogo: z.boolean(),
});

export type BrandDialogFormValue = z.infer<typeof brandDialogSchema>;
